import { useEffect, useState } from 'react'
import { supabase } from '@/lib/supabase'
import type { Order } from '@/types'

interface OrderWithItems extends Order {
  order_items?: Array<{
    id: string
    produk_id: string
    nama_produk: string
    harga_satuan: number
    qty: number
    subtotal: number
  }>
}

export function useOrder(id: string) {
  const [order, setOrder] = useState<OrderWithItems | null>(null)
  const [loading, setLoading] = useState(true)
  const [notFound, setNotFound] = useState(false)

  useEffect(() => {
    if (!id) return

    Promise.all([
      supabase
        .from('orders')
        .select('*')
        .eq('id', id)
        .single(),
      supabase
        .from('order_items')
        .select('*')
        .eq('order_id', id)
    ]).then(([orderRes, itemsRes]) => {
      if (orderRes.data) {
        setOrder({
          ...orderRes.data,
          order_items: itemsRes.data || []
        })
      } else {
        setNotFound(true)
      }
      setLoading(false)
    })
  }, [id])

  return { order, loading, notFound }
}
